// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ubW-a","isDesktop":"styles_isDesktop__ZyZuq","small":"styles_small__NA5QG","sMedium":"styles_sMedium__1jqXm","medium":"styles_medium__V1uUI"};